module.exports = __webpack_public_path__ + "static/media/nspa_logo_wht2.613ad38e.png";